import { Helmet } from "react-helmet-async";

const NOINDEX_HOSTS = ['staging.southcrete.com', 'dev.southcrete.com'];

const PageMetaData = ({
  title,
  description,
  keywords,
  image,
  url,
  canonicalOverride,
  noIndex = false,
  type = "website",
  author = "South Crete Tours"
}) => {
  const hostname = typeof window !== 'undefined' ? window.location?.hostname || '' : '';
  const shouldNoIndex = noIndex || NOINDEX_HOSTS.includes(hostname);
  const siteUrl = "https://southcrete.com";
  const fullTitle = title ? `${title} | South Crete Tours - Premium Travel Agency in Crete` : "South Crete Tours - Premium Travel Agency in Crete";
  const metaDescription = description || "Your premium travel partner in Crete. Book hotels, tours, car rentals, and flights. Partner collaborations available.";
  const metaImage = image || `${siteUrl}/og-image.jpg`;
  const canonicalUrl = canonicalOverride || (url ? `${siteUrl}${url}` : siteUrl);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      <meta name="robots" content={shouldNoIndex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content="South Crete Tours" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={metaImage} />

      {/* Additional SEO */}
      <meta name="geo.region" content="GR-94" />
      <meta name="geo.placename" content="Crete, Greece" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
    </Helmet>
  );
};

export default PageMetaData;
